import { jsonMember, jsonObject } from 'typedjson';
import { Id } from '@shared/types/id';
import { FileResponse } from '@api/file/responses/file.response';

@jsonObject
export class SequenceDetailsResponse {
  @jsonMember readonly id!: Id;
  @jsonMember readonly name!: string;
  @jsonMember readonly createdAt!: Date;
  @jsonMember readonly generatedAt!: Date;
  @jsonMember({ name: 'comment' }) readonly description!: string;
  @jsonMember readonly convertedSequence!: string;
  @jsonMember readonly file!: FileResponse;
}
